import * as types from '../ActionTypes/UserActionTypes';
import { UserModel } from '../../BusinessLogic/Models/UserModel';
import { statusCodes } from '../../Constants/statusCodes';
import {
    handleUnprocessableEntityAuthenticationErrors,
    handleUnauthorizedAuthenticationErrors,
} from '../../BusinessLogic/Errors/AuthenticationErrors';

const initialState = {
    meta: {
        uploadingImageResult: 0,
    },
    statuses: {
        isUserSigningIn: false,
        isGymSigningUp: false,
        isStandardUserSigningUp: false,
        isRestoreEmailSending: false,
        // isPasswordUpdating: false,
        isUserLoading: false,
        arePreferencesLoading: false,
    },
    currentUserPreferences: {},
    currentUser: {},
    authenticationErrors: {},
};

export function UserReducer(state = initialState, { type, payload }) {
    switch (type) {
        // register gym
        case types.REGISTER_GYM_USER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isGymSigningUp: true,
                },
            };
        }

        case types.REGISTER_GYM_USER_FAILED: {
            let errors = {};
            if (payload.response.status === statusCodes.UNPROCESSABLE_ENTITY)
                errors = handleUnprocessableEntityAuthenticationErrors(payload.response.data);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isGymSigningUp: false,
                },
                authenticationErrors: errors,
            };
        }

        // uploading user avatar
        case types.UPLOADING_USER_AVATAR_PROCESS: {
            return {
                ...state,
                meta: {
                    uploadingImageResult: payload,
                },
            };
        }

        // case types.UPLOADING_USER_AVATAR_FINISHED:
        //     return {
        //         ...state,
        //         meta: {
        //             uploadingImageResult: 0
        //         },
        //     };

        // register standard user
        case types.REGISTER_STANDARD_USER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isStandardUserSigningUp: true,
                },
            };
        }

        case types.REGISTER_STANDARD_USER_FAILED: {
            let errors = {};
            if (payload.response.status === statusCodes.UNPROCESSABLE_ENTITY)
                errors = handleUnprocessableEntityAuthenticationErrors(payload.response.data);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isStandardUserSigningUp: false,
                },
                authenticationErrors: errors,
            };
        }

        // sign in user
        case types.SIGN_IN_USER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isUserSigningIn: true,
                },
            };
        }

        case types.SIGN_IN_USER_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isUserSigningIn: false,
                    isGymSigningUp: false,
                    isStandardUserSigningUp: false,
                },
            };
        }

        case types.SIGN_IN_USER_FAILED: {
            let errors = {};
            if (payload.response.status === statusCodes.UNAUTHORIZED)
                errors = handleUnauthorizedAuthenticationErrors(payload.response.data);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isUserSigningIn: false,
                },
                authenticationErrors: errors,
            };
        }

        // forgot password
        case types.FORGOT_PASSWORD_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isRestoreEmailSending: true,
                },
            };
        }

        case types.FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isRestoreEmailSending: false,
                },
            };
        }

        case types.FORGOT_PASSWORD_FAILED: {
            let errors = {};
            if (payload.response.status === statusCodes.UNPROCESSABLE_ENTITY)
                errors = handleUnprocessableEntityAuthenticationErrors(payload.response.data);

            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isRestoreEmailSending: false,
                },
                authenticationErrors: errors,
            };
        }

        // get authenticated user
        case types.GET_AUTHENTICATED_USER_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    isUserLoading: true,
                },
            };
        }

        case types.GET_AUTHENTICATED_USER_SUCCESS: {
            const user = new UserModel(payload);

            return {
                ...state,
                currentUser: { ...user.user },
                statuses: {
                    ...state.statuses,
                    isUserLoading: false,
                },
            };
        }

        // get authenticated user preferences
        case types.GET_AUTHENTICATED_USER_PREFERENCES_REQUEST: {
            return {
                ...state,
                statuses: {
                    ...state.statuses,
                    arePreferencesLoading: true,
                },
            };
        }

        case types.GET_AUTHENTICATED_USER_PREFERENCES_SUCCESS: {
            return {
                ...state,
                currentUserPreferences: payload,
                statuses: {
                    ...state.statuses,
                    arePreferencesLoading: false,
                },
            };
        }

        case types.SIGN_OUT_USER_REQUEST: {
            return { ...initialState };
        }

        case types.CLEAR_AUTHENTICATION_ERRORS: {
            return {
                ...state,
                authenticationErrors: {},
            };
        }

        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/UserReducer.js